<template>
  <ul>
    <li v-for="item in side_bar_data" :key="item.tittle">
      <h6 class="submenu-hdr">
        <span>{{ item.tittle }}</span>
      </h6>
      <ul>
        <template v-for="menu in item.menu" :key="menu.menuValue">
          <!-- Render menu item without sub-route -->
          <li v-if="!menu.hasSubRoute && canAccessMenu(menu)">
            <router-link
              v-if="menu.route"
              :to="menu.route"
              :class="{ active: isMenuActive(menu) }"
              @click="expandSubMenus(menu)"
            >
              <i class="ti" :class="'ti-' + menu.icon"></i>
              <span>{{ menu.menuValue }}</span>
            </router-link>
          </li>

          <!-- Render menu item with sub-route -->
          <li class="submenu" v-if="menu.hasSubRoute && canAccessMenu(menu)">
            <a
              href="javascript:void(0)"
              @click="expandSubMenus(menu)"
              :class="{
                subdrop: menu.showSubRoute,
                active: route_array[1] === menu.active_link,
              }"
            >
              <i class="ti" :class="'ti-' + menu.icon"></i>
              <span>{{ menu.menuValue }}</span>
              <span class="menu-arrow"></span>
            </a>
            <ul
              :class="{
                'd-block': menu.showSubRoute,
                'd-none': !menu.showSubRoute,
              }"
            >
              <li v-for="subMenu in menu.subMenus" :key="subMenu.menuValue">
                <!-- Ensure that the submenu is only displayed if the user has permission -->
                <router-link
                  v-if="canAccessSubMenu(subMenu)"
                  :to="subMenu.route"
                  :class="{ active: currentPath === subMenu.active_link }"
                >
                  {{ subMenu.menuValue }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Render menu item with second sub-route -->
          <li v-if="menu.hasSubRouteTwo && canAccessMenu(menu)" class="submenu">
            <a
              href="javascript:void(0);"
              @click="openMenu(menu)"
              :class="{
                subdrop: menu.menuValue === 'Application' && isMenuActive(menu),
                active: isMenuActive(menu),
              }"
            >
              <i class="ti" :class="'ti-' + menu.icon"></i>
              <span>{{ menu.menuValue }}</span>
              <span class="menu-arrow"></span>
            </a>
            <ul
              :class="{
                'd-block': openMenuItem === menu,
                'd-none': openMenuItem !== menu,
              }"
            >
              <template
                v-for="subMenus in menu.subMenus"
                :key="subMenus.menuValue"
              >
                <!-- Render sub-menu without custom sub-menu -->
                <li
                  v-if="
                    !subMenus.customSubmenuTwo && canAccessSubMenu(subMenus)
                  "
                >
                  <router-link :to="subMenus.route">
                    {{ subMenus.menuValue }}
                  </router-link>
                </li>

                <!-- Render sub-menu with custom sub-menu -->
                <template v-else-if="subMenus.customSubmenuTwo">
                  <li class="submenu" v-if="canAccessSubMenu(subMenus)">
                    <a
                      href="javascript:void(0);"
                      @click="openSubmenuOne(subMenus)"
                      :class="{
                        subdrop: showSubRoute === subMenus,
                        active: route_array[1] === subMenus.active_link,
                      }"
                    >
                      {{ subMenus.menuValue }}
                      <span class="menu-arrow"></span>
                    </a>
                    <ul
                      :class="{
                        'd-block': showSubRoute === subMenus,
                        'd-none': showSubRoute !== subMenus,
                      }"
                    >
                      <li
                        v-for="subMenuTwo in subMenus.subMenusTwo"
                        :key="subMenuTwo.menuValue"
                      >
                        <router-link :to="subMenuTwo.route">{{
                          subMenuTwo.menuValue
                        }}</router-link>
                      </li>
                    </ul>
                  </li>
                </template>
              </template>
            </ul>
          </li>
        </template>
      </ul>
    </li>
  </ul>
</template>

<script>
import side_bar_data from "@/assets/json/sidebar-data.json";
import http from "@/utils/http";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      side_bar_data: side_bar_data,
      openMenuItem: null,
      showSubRoute: null,
      route_array: [],
      multilevel: [false, false, false],

    };
  },
  methods: {
    expandSubMenus(menu) {
      this.side_bar_data.forEach((item) => {
        if (item.menu && Array.isArray(item.menu)) {
          item.menu.forEach((subMenu) => {
            if (subMenu !== menu) {
              subMenu.showSubRoute = false;
              subMenu.showSubRoute1 = false;
            }
          });
        }
      });
      menu.showSubRoute = !menu.showSubRoute;
    },
    openMenu(menu) {
      this.openMenuItem = this.openMenuItem === menu ? null : menu;
    },
    openSubmenuOne(subMenus) {
      this.showSubRoute = this.showSubRoute === subMenus ? null : subMenus;
    },
    getCurrentPath() {
      this.route_array = this.$route.path.split("/");
      return this.$route.path;
    },

    canAccessMenu(menu) {
      // Ensure userPermissions is an array before using includes
      if (
        Array.isArray(this.userPermissions) &&
        menu.permissions &&
        Array.isArray(menu.permissions)
      ) {
        return menu.permissions.some((permission) =>
          this.userPermissions.includes(permission)
        );
      }
      return true; // Allow access if no specific permissions required or userPermissions is undefined
    },
    canAccessSubMenu(subMenu) {
      if (
        Array.isArray(this.userPermissions) &&
        subMenu.permissions &&
        Array.isArray(subMenu.permissions)
      ) {
        return subMenu.permissions.some((permission) =>
          this.userPermissions.includes(permission)
        );
      }
      return true; // Allow access if no specific permissions required or userPermissions is undefined
    },
  },

  computed: {
    ...mapGetters(["userRoles","userPermissions"]),
    currentPath() {
      return this.getCurrentPath();
    },
    isMenuActive() {
      return (menu) => {
        if (menu.menuValue === "Application") {
          return (
            this.$route.path.startsWith("/application") || // Check if current route starts with '/application'
            this.$route.path.startsWith("/call") ||
            this.$route.path === menu.active_link ||
            this.$route.path === menu.active_link1 ||
            this.$route.path === menu.active_link2
          );
        } else {
          return (
            this.$route.path === menu.route ||
            this.$route.path === menu.active_link ||
            this.$route.path === menu.active_link1 ||
            this.$route.path === menu.active_link2 ||
            this.$route.path === menu.active_link3 ||
            this.$route.path === menu.active_link4 ||
            this.$route.path === menu.active_link5 ||
            this.$route.path === menu.active_link6 ||
            this.$route.path === menu.active_link7 ||
            this.$route.path === menu.active_link8 ||
            this.$route.path === menu.active_link9 ||
            this.$route.path === menu.active_link10 ||
            this.$route.path === menu.active_link11
          );
        }
      };
    },
  },

};
</script>
